import { cloneDeep, isMatch, snakeCase } from 'lodash';

export class ShopPickerController {

  selectedShop;
  selectedMonth;
  loadingDates = false;
  dates = [];
  list = [];
  onSelected: Function;
  isSelected: boolean;
  autosend: boolean;
  onReset: Function;
  /*@ngInject*/
  constructor(private Shop, private DailyReport) {

  }

  $onInit() {
    this.refreshData();
  }

  private refreshData() {
    this.Shop.query((result) => {
      this.list = result;
    });
  }

  shopSelected(shop) {
    this.loadingDates = true;
    // console.log('shop selected', shop);
    this.selectedShop = shop;
    this.reset();
    this.DailyReport.dates({ id: this.selectedShop._id }, (result) => {
      // console.log('dates', result);
      this.dates = result;
      this.loadingDates = false;
    });
  }
  reset() {
    this.dates = [];
    if (this.onReset) {
      this.onReset();
    }
  }
  selected() {
    if (this.selectedShop && this.selectedMonth) {
      this.isSelected = true;
      this.onSelected({ shop: this.selectedShop, month: this.selectedMonth });
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/shopPicker/shopPicker.controller.ts